import React from 'react'
import ReactModal from 'react-modal'
import PropTypes from 'prop-types'
import { IoIosClose } from 'react-icons/io'
import Component from './Component'
import '../../css/Modal.scss'

export default class Modal extends Component {
  static propTypes = {
    handleClose: PropTypes.func.isRequired,
    className: PropTypes.string,
    isOpen: PropTypes.bool
  }

  static defaultProps = {
    isOpen: true
  }

  constructor(props) {
    super(props)

    this.state = { isOpen: props.isOpen }
  }

  handleClose = () => {
    this.setState({ isOpen: false }, () => {
      this.props.handleClose()
    })
  }

  render() {
    return (
      <ReactModal
        isOpen={this.state.isOpen}
        onRequestClose={this.handleClose}
        appElement={document.getElementById('root')}
        portalClassName={`modal ${this.props.className}`}
        overlayClassName="modal__overlay"
        className="modal__content"
        role="modal"
      >
        {this.props.children}

        <button
          className="modal__close"
          type="button"
          onClick={this.handleClose}
        >
          <IoIosClose />
        </button>
      </ReactModal>
    )
  }
}
